import { useEffect } from 'react';
import { useAccess } from '@/lib/access';

// UI-only companion to server permissions for existing prototype controls.
// Attribute selectors keep this independent of labels, translations and layout.
const WRITES = [
  '[data-testid="rugby-upload-card"]', '[data-testid="rugby-branding-button"]',
  '[data-testid^="rugby-clip-menu-"]', '[data-testid^="rugby-clip-retry-"]',
  '[data-testid^="game-confirm-"]', '[data-testid="profile-notes-save"]',
  '[data-testid^="lab-player-identity-"]', '[data-testid^="tournament-schedule-"]',
  '[data-testid^="label-studio-open-"]', '[data-testid="lab-measurement-workspace"]',
  '[data-testid="lab-analyst"]', '[data-testid="review-penalty-at-moment"]',
  '[data-testid="review-try-at-moment"]', '[data-testid^="manual-review-retry-"]',
  '[data-testid^="manual-human-confirm-"]', '[data-testid^="manual-human-dismiss-"]', '[data-testid^="manual-human-unsure-"]',
  '[data-testid="header-ask-analyst-button"]', '[data-testid="lab-ask-analyst-button"]',
  '[data-testid="rugby-ask-analyst"]', '[data-testid*="-ask-"]',
  '[data-testid="lab-upload-panel"]', '[data-testid="lab-rerun-button"]', '[data-testid="lab-delete-button"]',
  '[data-testid^="lab-queue-remove-"]', '[data-testid^="lab-queue-retry-"]', '[data-testid="lab-retry-button"]',
  '[data-testid="lab-edit-details-button"]', '[data-testid="lab-analytics-switch"]',
  '[data-testid="lab-analytics-reset"]', '[data-testid="rugby-analyst-button"]',
  '[data-testid^="explain-call-"]', '[data-testid^="translation-edit-"]',
  '[data-testid^="tournament-split-"]', '[data-testid="rugby-wearable-toggle"]',
];
const LOCK_FIELDS = '[data-testid="profile-notes"], [data-testid^="manual-human-note-"]';
export const AccessControls=()=>{
  const {mode}=useAccess();
  useEffect(()=>{
    if(!['read_only','presenter'].includes(mode))return;
    const update=()=>{
      document.querySelectorAll(WRITES.join(',')).forEach(el=>{if(!el.hasAttribute('data-access-hidden')){el.setAttribute('data-access-hidden','true');el.hidden=true;}});
      document.querySelectorAll(LOCK_FIELDS).forEach(el=>{el.readOnly=true;});
    };
    update();const observer=new MutationObserver(update);observer.observe(document.body,{childList:true,subtree:true});
    return()=>{observer.disconnect();document.querySelectorAll('[data-access-hidden]').forEach(el=>{el.hidden=false;el.removeAttribute('data-access-hidden');});document.querySelectorAll(LOCK_FIELDS).forEach(el=>{el.readOnly=false;});};
  },[mode]);
  return null;
};